<template>
    <div :class="containerClasses">
        <div
            :class="spinnerClasses"
            aria-hidden="false"
            role="status"
            class="slds-spinner"
        >
            <span class="slds-assistive-text">{{ loadingLabel }}</span>
            <div class="slds-spinner__dot-a"></div>
            <div class="slds-spinner__dot-b"></div>
        </div>
        <div
            v-if="$slots['loading-description']"
            class="loading-description"
        >
            <div
                aria-live="assertive"
                class="slds-grid slds-grid_vertical slds-p-top_xx-large slds-text-align_center"
            >
                <slot name="loading-description"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MASpinner',
        props: {
            theme: {
                type: String,
                default: '',
                validator: (value) => {
                    const validThemes = ['', 'brand', 'inverse'];
                    const isValid = validThemes.includes(value);
                    if (!isValid) console.error(`Valid theme prop values are ${validThemes.join(', ')}`);
                    return isValid;
                }
            },
            size: {
                type: String,
                default: 'medium',
                validator: (value) => {
                    const validSizes = ['xx-small', 'x-small', 'small', 'medium', 'large'];
                    const isValid = validSizes.includes(value);
                    if (!isValid) console.error(`Valid size prop values are ${validSizes.join(', ')}`);
                    return isValid;
                }
            },
            delayedStart: {
                type: Boolean,
                default: false
            },
            withoutContainer: {
                type: Boolean,
                default: false
            },
            isFixed: {
                type: Boolean,
                default: false
            },
            loadingLabel: {
                type: String,
                default: 'Loading'
            }
        },
        computed: {
            spinnerClasses() {
                const classes = [];
                if (this.theme) classes.push(`slds-spinner_${this.theme}`);
                if (this.delayedStart) classes.push('slds-spinner_delayed');
                if (this.size) classes.push(`slds-spinner_${this.size}`);
                return classes;
            },
            containerClasses() {
                const classes = [];
                if (!this.withoutContainer || !this.$slots['loading-description']) classes.push('slds-spinner_container');
                if (this.isFixed) classes.push('slds-is-fixed');
                return classes;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .loading-description {
        position: absolute;
        top: 50%;
        width: 100%;
        text-align: center;
        padding: 0;
    }
</style>
